import type { Project } from './types';

export interface VisitStop {
  time: string | null;
  project: Project | null;
  travel: string | null;
}

const DEFAULT_TIMES = ['11:00 AM', '12:30 PM', '2:00 PM', '3:30 PM'];

/** Build a simple Saturday timeline from the buyer's shortlist (demo-grade routing). */
export function buildVisitStops(projects: Project[]): VisitStop[] {
  if (projects.length === 0) return [];

  const stops: VisitStop[] = [];
  projects.slice(0, 4).forEach((project, i) => {
    if (i > 0) {
      stops.push({
        time: null,
        project: null,
        travel: `~${25 + i * 10} min drive`,
      });
    }
    stops.push({
      time: DEFAULT_TIMES[i] ?? `${11 + i}:00 AM`,
      project,
      travel: null,
    });
  });
  return stops;
}

export function primaryVisitProject(projects: Project[]): Project | null {
  return projects[0] ?? null;
}
